import Layout from '@/layout/index.vue'

export const setMap = {
  path: '/set',
  component: Layout,
  meta: { title: '设置', code: 102019 },
  children: [
    {
      path: 'set',
      component: () => import('@/views/set/courseSet/index.vue'),
      meta: { title: '课程设置', drop: true, code: 714037 },
      children: [
        {
          path: 'evaluation',
          meta: { title: '课程设置', code: 444231 },
          component: () => import('@/views/set/courseSet/courseSet/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/set/courseSet/courseSet/list.vue'),
              meta: { title: '课程设置', keepAlive: true }
            }
          ]
        }
      ]
    }
  ]
}
